import Spinner from 'react-bootstrap/Spinner';
const SpinNer = () => {
  return (
    <Spinner animation="border" />
  )
}

export default SpinNer